import React, { useState } from "react";
import close from "../../assets/icons/close.svg";
import { Postdata } from "../../API/GlobalApi";
import Notifier from "../../Utils/notify";
import Session from "../../Utils/Sessions";
import '../../assets/css/Modal.css'
import { createPortal } from 'react-dom';

export const CreatePIN = ({ isOpen, onClose, pin, setPin, otp }) => {
    const [confirmPin, setConfirmPin] = useState("");
    const [enteredOtp, setEnteredOtp] = useState("");
    const [loading, setLoading] = useState(false);

    if (!isOpen) return null;

    // Handler for PIN only
    const handlePinSubmit = async () => {
        if (pin.length !== 4 || confirmPin.length !== 4) {
            Notifier.error("PIN must be 4 digits");
            return;
        }
        if (pin !== confirmPin) {
            Notifier.error("PINs do not match");
            return;
        }

        try {
            setLoading(true);
            const payload = { pin, pin_copy: confirmPin };
            const res = await Postdata("core/get-or-create-user-pin/", payload);
            if (!res?.error) {
                Notifier.success("PIN created successfully");
                Session.set('security_pin', true);
                setPin("");
                setConfirmPin("");
                setEnteredOtp("");
                onClose();
            } else {
                Notifier.error(res?.data?.message || "Failed to create PIN");
            }
        } catch (err) {
            console.error("Error creating PIN:", err);
            Notifier.error("Something went wrong while creating PIN");
        } finally {
            setLoading(false);
        }
    };

    // Handler for OTP + PIN
    const handlePinWithOtpSubmit = async () => {
        if (!enteredOtp) {
            Notifier.error("Enter OTP");
            return;
        }
        if (pin.length !== 4 || confirmPin.length !== 4) {
            Notifier.error("PIN must be 4 digits");
            return;
        }
        if (pin !== confirmPin) {
            Notifier.error("PINs do not match");
            return;
        }
        try {
            setLoading(true);
            const payload = { pin, pin_copy: confirmPin, otp: enteredOtp };
            const res = await Postdata("core/update-user-pin/", payload);

            if (!res?.error) {
                Notifier.success(res?.message);
                Session.set('security_pin', true);
                setPin("");
                setConfirmPin("");
                setEnteredOtp("");
                onClose();
            } else {
                Notifier.error(res?.error || "OTP verification failed");
            }
        } catch (err) {
            console.error("Error verifying OTP:", err);
            Notifier.error("Something went wrong while verifying OTP");
        } finally {
            setLoading(false);
        }
    };


    return createPortal(
        <div className="modal-overlay">
            <div
                className="modal-content recevingPaymentBody"
                style={{
                    position: "relative",
                    width: "30%",
                    display: "flex",
                    flexDirection: "column",
                    overflowY: "auto",
                    minHeight: "40vh",  
                    maxHeight: "80vh",  
                    height: 'auto',
                    padding: "20px",
                }}
            >
                {/* Header */}
                <div
                    className="modal-header-content"
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "10px",
                    }}
                >
                    <h2 className="text-primary">{otp ? "Verify OTP & Reset PIN" : "Create PIN"}</h2>
                    <button className="close-btn" onClick={onClose}>
                        <img src={close} alt="close" />
                    </button>
                </div>

                {/* Body */}
                <div style={{ flex: 1 }}>
                    {otp && (
                        <div className="mb-3">
                            <label className="form-labell">Enter OTP</label>
                            <input
                                type="text"
                                maxLength={6}
                                className="form-control"
                                value={enteredOtp}
                                onChange={(e) => setEnteredOtp(e.target.value.replace(/\D/g, ""))}
                                placeholder="Enter OTP"
                            />
                        </div>
                    )}

                    <div className="mb-3">
                        <label className="form-labell">Enter PIN</label>
                        <input
                            type="password"
                            maxLength={4}
                            className="form-control"
                            value={pin}
                            onChange={(e) => setPin(e.target.value.replace(/\D/g, ""))}
                            placeholder="Enter 4-digit PIN"
                        />
                    </div>
                    <div className="mb-3">
                        <label className="form-labell">Confirm PIN</label>
                        <input
                            type="password"
                            maxLength={4}
                            className="form-control"
                            value={confirmPin}
                            onChange={(e) => setConfirmPin(e.target.value.replace(/\D/g, ""))}
                            placeholder="Re-enter 4-digit PIN"
                        />
                    </div>
                </div>

                {/* Footer */}
                <div style={{ display: 'flex', justifyContent: 'end' }}>
                    <button
                        className="add-btn"
                        style={{
                            padding: "10px 20px",
                            backgroundColor:
                                otp ? enteredOtp && pin && confirmPin ? "#7F56DA" : "#d3d3d3"
                                    : pin && confirmPin ? "#7F56DA" : "#d3d3d3",
                            cursor:
                                otp ? enteredOtp && pin && confirmPin ? "pointer" : "not-allowed"
                                    : pin && confirmPin ? "pointer" : "not-allowed",
                        }}
                        disabled={loading || !pin || !confirmPin || (otp && !enteredOtp)}
                        onClick={otp ? handlePinWithOtpSubmit : handlePinSubmit}
                    >
                        {loading ? "Saving..." : otp ? "Verify & Save" : "Save PIN"}
                    </button>
                </div>
            </div>
        </div>, document.body
    );
};
